import vertexShader from "./shader.vert";
import fragmentShader from "./shader.frag";

export default {
  uniforms: {
    texture: { value: null },
    delta: { value: { x: 0, y: 0 } }
  },
  vertexShader,
  fragmentShader
};
